import axios from 'axios'

const client = axios.create({
  baseURL: '/api/console',
  withCredentials: true,
})

let refreshPromise = null

client.interceptors.response.use(
  response => response,
  async error => {
    const request = error.config || {}
    const isRefreshable = error.response && error.response.status === 401 &&
      !request.__consoleRetried && !String(request.url || '').includes('/auth/refresh') &&
      !String(request.url || '').includes('/auth/google')

    if (!isRefreshable) return Promise.reject(error)
    request.__consoleRetried = true
    if (!refreshPromise) {
      refreshPromise = client.post('/auth/refresh').finally(() => { refreshPromise = null })
    }
    await refreshPromise
    return client(request)
  }
)

export const consoleAuthClient = {
  async login(credential) {
    const response = await client.post('/auth/google', { credential })
    return response.data.user
  },
  async me() {
    const response = await client.get('/auth/me')
    return response.data.user
  },
  async logout() {
    await client.post('/auth/logout')
  },
}

export const consoleUserClient = {
  async list(params = {}) {
    const response = await client.get('/users', { params })
    return response.data
  },
  async create(input) {
    const response = await client.post('/users', input)
    return response.data.user
  },
  async update(id, input) {
    const response = await client.patch(`/users/${id}`, input)
    return response.data.user
  },
  async deactivate(id) {
    const response = await client.delete(`/users/${id}`)
    return response.data.user
  },
}

export const consoleOperationsClient = {
  async paymentRecovery(id, page = 1) { return (await client.get(`/operations/members/${encodeURIComponent(id)}/payment-recovery`, { params: { page } })).data },
  async verifyPayment(id, input) { return (await client.post(`/operations/members/${encodeURIComponent(id)}/payment-recovery/verify`, input)).data },
  async paymentToken(id, input) { return (await client.post(`/operations/members/${encodeURIComponent(id)}/payment-recovery/token`, input)).data },
  async recoverPayment(id, input) { return (await client.post(`/operations/members/${encodeURIComponent(id)}/payment-recovery/apply`, input)).data },
  async grantMembership(id, input) { return (await client.post(`/operations/members/${encodeURIComponent(id)}/grants`, input)).data },
  async revokeMembership(id, grantId, input) { return (await client.post(`/operations/members/${encodeURIComponent(id)}/grants/${encodeURIComponent(grantId)}/revoke`, input)).data },
  async list(resource, params = {}) { return (await client.get(`/operations/${resource}`, { params })).data },
  async detail(resource, id) { return (await client.get(`/operations/${resource}/${encodeURIComponent(id)}`)).data },
  async reviewReport(id, input) { return (await client.patch(`/operations/reports/${encodeURIComponent(id)}`, input)).data },
}
